import { AdSystemT } from "../graphql/generated/graphql";

const STORAGE_KEY = "shoptet_budget_modal_return";
const MAX_AGE_MS = 60 * 60 * 1000;

type BudgetModalReturnT = {
  adSystem: AdSystemT;
  budget: number;
  storedAt: number;
};

export const storeBudgetModalReturn = (adSystem: AdSystemT, budget: number) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ adSystem, budget, storedAt: Date.now() }));
};

export const clearBudgetModalReturn = () => {
  localStorage.removeItem(STORAGE_KEY);
};

export const readBudgetModalReturn = (adSystem: AdSystemT): BudgetModalReturnT | null => {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }
  try {
    const stored: BudgetModalReturnT = JSON.parse(raw);
    if (stored.adSystem !== adSystem || Date.now() - stored.storedAt > MAX_AGE_MS) {
      return null;
    }
    return stored;
  } catch {
    return null;
  }
};
